// ENUMS FOR WORK ORDER TYPES
const workOrderTypes = {
    VISIT: 'visit',
    LAB: 'lab',

};
export default Object.freeze(workOrderTypes);
